 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","home~0b73c639":"home~0b73c639","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"46f7ead8","chunk-19b0cf18":"dca66e12","chunk-1c809755":"c5a3ce1b","chunk-27893c0e":"309fdddf","chunk-2d0aab45":"b2cc2107","chunk-2d0cc1d9":"6b8ecb7e","chunk-2f072b3b":"2e6c82d5","chunk-2fd16595":"70beea8f","chunk-3d370fbd":"690e3acb","chunk-4fc4313d":"37c59751","chunk-5069aa76":"c7c03403","chunk-5843f5f5":"b8347825","chunk-5a866570":"35f56986","chunk-75fa76d9":"3b5778e5","chunk-7bb3ad42":"e15a5ebe","chunk-962d79fe":"d8b74c82","chunk-9d5ffe78":"81d64ce9","chunk-commons~d939e436":"8de2a971","chunk-commons~f71cff67":"cf49da1e","chunk-commons~21833f8f":"9cf6417e","chunk-033d0fac":"316419b9","chunk-17187794":"42fd35fa","chunk-18f4cd76":"f5286db9","chunk-20096cde":"14d235b2","chunk-21e49a6a":"ed744767","chunk-23ccfade":"e3afa84a","chunk-241ff04f":"ca113392","chunk-278f15c2":"036aceab","chunk-2d0a30ec":"22e8c8f4","chunk-2d0c917a":"4c955db1","chunk-2d0da362":"9f4a11c3","chunk-2d0daf52":"df5b9b71","chunk-2d0e4810":"7cf516ba","chunk-2d0efccf":"a2627c74","chunk-2d207d1a":"72456b96","chunk-2d2140d8":"153722e5","chunk-2d217776":"cae6bd26","chunk-2d226c7a":"f00b6c20","chunk-31c554f9":"bb60f445","chunk-32e93b49":"c77b1e54","chunk-33e0108f":"dec83e2a","chunk-460b9760":"76f44570","chunk-46a258dd":"5cc95186","chunk-4962705e":"f4b9ce17","chunk-501c63ff":"e8e3e49b","chunk-2908a9fd":"e24c0205","chunk-5531d079":"7ae7f193","chunk-55cbd2c4":"dd5a6482","chunk-59f69480":"0e14a9b5","chunk-6627835c":"04d0ef85","chunk-a8d25112":"389c2512","chunk-e4d08274":"4e9dcff9","chunk-fa749f4a":"f5805299","chunk-fe24d09c":"521d8462","home~0b73c639":"102a67fa","sentiment~21833f8f":"5f23ed40","user~6e76d53f":"b81ca245","wonder~a0a3fe25":"4049013e","chunk-d28e359a":"1c8a7a4b","chunk-d36bd4fa":"bb960544","chunk-ef49d6e2":"e69e7411","chunk-21a8c3e2":"a14af71e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05a29214":1,"chunk-19b0cf18":1,"chunk-1c809755":1,"chunk-27893c0e":1,"chunk-2f072b3b":1,"chunk-3d370fbd":1,"chunk-4fc4313d":1,"chunk-5843f5f5":1,"chunk-5a866570":1,"chunk-75fa76d9":1,"chunk-7bb3ad42":1,"chunk-962d79fe":1,"chunk-9d5ffe78":1,"chunk-commons~f71cff67":1,"chunk-commons~21833f8f":1,"chunk-033d0fac":1,"chunk-17187794":1,"chunk-18f4cd76":1,"chunk-20096cde":1,"chunk-21e49a6a":1,"chunk-23ccfade":1,"chunk-241ff04f":1,"chunk-278f15c2":1,"chunk-31c554f9":1,"chunk-32e93b49":1,"chunk-33e0108f":1,"chunk-460b9760":1,"chunk-46a258dd":1,"chunk-4962705e":1,"chunk-2908a9fd":1,"chunk-5531d079":1,"chunk-55cbd2c4":1,"chunk-59f69480":1,"chunk-6627835c":1,"chunk-a8d25112":1,"chunk-e4d08274":1,"chunk-fa749f4a":1,"chunk-fe24d09c":1,"home~0b73c639":1,"sentiment~21833f8f":1,"user~6e76d53f":1,"wonder~a0a3fe25":1,"chunk-d28e359a":1,"chunk-d36bd4fa":1,"chunk-ef49d6e2":1,"chunk-21a8c3e2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","home~0b73c639":"home~0b73c639","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"20d2b46c","chunk-19b0cf18":"3a86a2cb","chunk-1c809755":"f96e9b7e","chunk-27893c0e":"ad600f2e","chunk-2d0aab45":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2f072b3b":"c6462fb6","chunk-2fd16595":"31d6cfe0","chunk-3d370fbd":"064cab12","chunk-4fc4313d":"80994280","chunk-5069aa76":"31d6cfe0","chunk-5843f5f5":"0a499fb1","chunk-5a866570":"6a1b8051","chunk-75fa76d9":"0f317b67","chunk-7bb3ad42":"683048d4","chunk-962d79fe":"0382aabd","chunk-9d5ffe78":"891da3e2","chunk-commons~d939e436":"31d6cfe0","chunk-commons~f71cff67":"a414909c","chunk-commons~21833f8f":"76d3d9ca","chunk-033d0fac":"ff0244e2","chunk-17187794":"43a3ccd9","chunk-18f4cd76":"82a52af7","chunk-20096cde":"48f76a78","chunk-21e49a6a":"47f03dd4","chunk-23ccfade":"34b94229","chunk-241ff04f":"9717d7ab","chunk-278f15c2":"5c5c2664","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-31c554f9":"4af798f3","chunk-32e93b49":"258ec01b","chunk-33e0108f":"69a60952","chunk-460b9760":"f7975acd","chunk-46a258dd":"d2558648","chunk-4962705e":"35010b62","chunk-501c63ff":"31d6cfe0","chunk-2908a9fd":"bced7067","chunk-5531d079":"939147fd","chunk-55cbd2c4":"6758766b","chunk-59f69480":"b934bf48","chunk-6627835c":"1463a986","chunk-a8d25112":"43d684f4","chunk-e4d08274":"eb0c82c6","chunk-fa749f4a":"dd996a2a","chunk-fe24d09c":"4333e9de","home~0b73c639":"f730c261","sentiment~21833f8f":"fa5bffaf","user~6e76d53f":"6058c424","wonder~a0a3fe25":"40bfdcbf","chunk-d28e359a":"cefdfb45","chunk-d36bd4fa":"e18b6095","chunk-ef49d6e2":"aaed90ae","chunk-21a8c3e2":"a95e50a8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
